import * as e from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/Share.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(t, { ref: a, ...r, weights: m }));
o.displayName = "ShareIcon";
const n = o;
export {
  n as Share,
  o as ShareIcon
};
